<!-- 雨量站详情弹框 -->
<template>
  <div class="ylz_container">
    <div class="title">{{ currentData.stnm }}</div>
    <div class="info_content">
      <div class="info_item">
        <span class="item_category">站点类别：</span>
        <span style="margin-right: 1rem">{{ currentData.type }}</span>
      </div>
      <div class="info_item">
        <span class="item_category">测站编码：</span>
        <span>{{ currentData.stcd }}</span>
      </div>
    </div>
    <div class="factor_container">
      <div
        v-for="(factor, index) in currentData.factors"
        :key="index"
        class="factor"
        :class="{ active: currentFactor === factor }"
        @click="onFactorClick(factor)"
      >
        {{ factor }}
      </div>
      <div class="right-box">
        <!-- <div class="condition">
          <div
            class="echart-btn"
            :class="{ active: selectEchart === '时均值' }"
            @click="select('时均值')"
          >
            时均值
          </div>
          <div
            class="echart-btn"
            :class="{ active: selectEchart === '日均值' }"
            @click="select('日均值')"
          >
            日均值
          </div>
        </div> -->
        <n-date-picker
          v-model:value="time"
          size="small"
          type="date"
          clearable
          :on-update:value="onTimeChange"
          format="yyyy-MM-dd"
        />
      </div>
    </div>
    <div class="condition">
      <div class="benchmark">
        <span>百分位基准年限：</span>
        <n-select
          v-model:value="benchmark"
          :options="benchmarkOptions"
          @update:value="selectChange"
        />
      </div>
    </div>
    <div v-show="currentFactor === '水位'" ref="charts1" class="charts_container"></div>
    <div v-show="currentFactor === '流量'" ref="charts2" class="charts_container"></div>
    <div v-show="currentFactor === '雨量'" ref="charts3" class="charts_container"></div>
  </div>
</template>

<script setup lang="ts">
import { EChartsType } from 'echarts'
import { toRefs, nextTick, getCurrentInstance, onMounted, defineEmits } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
const { proxy } = getCurrentInstance()
const api = new Api()

const props = defineProps({
  data: Object,
})

const time = ref(new Date())
const selectEchart = ref('时均值')
const currentFactor = ref('')
const currentData = ref({})
const benchmark = ref('1')
const benchmarkOptions = ref([
  {
    label: '1年期',
    value: '1',
  },
  {
    label: '3年期',
    value: '3',
  },
  {
    label: '5年期',
    value: '5',
  },
])
let echart1Object = null
let echart2Object = null
let echart3Object = null
const charts1 = ref()
const charts2 = ref()
const charts3 = ref()
const graphData: any[] = []

const onFactorClick = (type: string) => {
  currentFactor.value = type
  // onFilterChange()
}
const initChart = async (data) => {
  const xdata: any[] = []
  const ydata: any[] = []
  let min = null
  const standardLine = await getStandardLine('水位')
  const markLine: Object = {
    silent: true,
    label: {
      color: '#fff',
    },
    lineStyle: {
      color: '#ffeb3b',
    },
    data: [],
  }
  if (standardLine.sevenLine) {
    markLine.data.push({
      name: '70%分位线',
      yAxis: standardLine.sevenLine,
      label: {
        formatter: '70%分位线',
      },
    })
  }
  if (standardLine.threeLine) {
    markLine.data.push({
      name: '30%分位线',
      yAxis: standardLine.threeLine,
      label: {
        formatter: '30%分位线',
      },
    })
  }
  if (standardLine.medianLine) {
    markLine.data.push({
      name: '平均值',
      yAxis: standardLine.medianLine,
      label: {
        formatter: '平均值',
      },
    })
  }
  data.forEach((item) => {
    xdata.push(item.t)
    ydata.push(item.d || 0)
    if (item.d && !min) {
      min = item.d * 1
    } else if (item.d && item.d * 1 < min * 1) {
      min = item.d * 1
    }
  })

  const colorArr = [
    {
      start: 'rgba(0,211,149,1)',
      end: 'rgba(0,211,149,.1)',
    },
  ]
  const normalColor = '#ffffff'
  const seriesData = []
  let obj1 = {}
  obj1 = {
    // type: 'bar',
    type: 'line',
    data: ydata,
    barWidth: '15%',
    markLine,
    itemStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: `${colorArr[0].start}0.7)`,
            },
            {
              offset: 0.5,
              color: `${colorArr[0].start}0.3)`,
            },
            {
              offset: 1,
              color: colorArr[0].end,
            },
          ],
          globalCoord: false,
        },
      },
    },
  }
  seriesData.push(obj1)
  echart1Object.clear()
  echart1Object.setOption({
    grid: {
      left: '2%',
      top: '14%',
      right: '12%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        name: '时',
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        data: xdata,
        axisPointer: {
          type: 'shadow',
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '水位(M)',
        min: min > 0.2 ? Math.floor((min - 0.2) * 10) / 10 : 0,
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(255, 255, 255, .5)',
          },
        },
      },
    ],
    series: seriesData,
  })
}
const initChart2 = async (data) => {
  const xdata: any[] = []
  const ydata: any[] = []
  const standardLine = await getStandardLine('流量')
  let min = null
  const markLine: Object = {
    silent: true,
    label: {
      color: '#fff',
    },
    lineStyle: {
      color: '#ffeb3b',
    },
    data: [],
  }
  if (standardLine.sevenLine) {
    markLine.data.push({
      name: '70%分位线',
      yAxis: standardLine.sevenLine,
      label: {
        formatter: '70%分位线',
      },
    })
  }
  if (standardLine.threeLine) {
    markLine.data.push({
      name: '30%分位线',
      yAxis: standardLine.threeLine,
      label: {
        formatter: '30%分位线',
      },
    })
  }
  if (standardLine.medianLine) {
    markLine.data.push({
      name: '平均值',
      yAxis: standardLine.medianLine,
      label: {
        formatter: '平均值',
      },
    })
  }

  data.forEach((item) => {
    xdata.push(item.t)
    ydata.push(item.d || 0)
    if (item.d && !min) {
      min = item.d * 1
    } else if (item.d && item.d * 1 < min * 1) {
      min = item.d * 1
    }
  })
  const colorArr = [
    {
      start: 'rgba(31,194,255,1)',
      end: 'rgba(31,194,255,.1)',
    },
  ]
  const normalColor = '#ffffff'
  const seriesData = []
  let obj1 = {}
  obj1 = {
    type: 'line',
    data: ydata,
    // barWidth: '15%',
    markLine,
    itemStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: `${colorArr[0].start}0.7)`,
            },
            {
              offset: 0.5,
              color: `${colorArr[0].start}0.3)`,
            },
            {
              offset: 1,
              color: colorArr[0].end,
            },
          ],
          globalCoord: false,
        },
      },
    },
  }
  seriesData.push(obj1)
  echart2Object.clear()
  echart2Object.setOption({
    grid: {
      left: '2%',
      top: '14%',
      right: '12%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: xdata,
        name: '时',
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisPointer: {
          type: 'shadow',
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '流量(M³/S)',
        min: min > 0.2 ? Math.floor((min - 0.2) * 10) / 10 : 0,
        nameTextStyle: {
          color: normalColor,
          fontSize: 12,
        },
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(255, 255, 255, .5)',
          },
        },
      },
    ],
    series: seriesData,
  })
}
const initChart3 = async (data) => {
  const xdata: any[] = []
  const ydata: any[] = []
  let min = null
  const standardLine = await getStandardLine('雨量')
  const markLine: Object = {
    silent: true,
    label: {
      color: '#fff',
    },
    lineStyle: {
      color: '#ffeb3b',
    },
    data: [],
  }
  if (standardLine.sevenLine) {
    markLine.data.push({
      name: '70%分位线',
      yAxis: standardLine.sevenLine,
      label: {
        formatter: '70%分位线',
      },
    })
  }
  if (standardLine.threeLine) {
    markLine.data.push({
      name: '30%分位线',
      yAxis: standardLine.threeLine,
      label: {
        formatter: '30%分位线',
      },
    })
  }
  if (standardLine.medianLine) {
    markLine.data.push({
      name: '平均值',
      yAxis: standardLine.medianLine,
      label: {
        formatter: '平均值',
      },
    })
  }
  data.forEach((item) => {
    xdata.push(item.t)
    ydata.push(item.d || 0)
    if (item.d && !min) {
      min = item.d * 1
    } else if (item.d && item.d * 1 < min * 1) {
      min = item.d * 1
    }
  })
  const normalColor = '#ffffff'
  echart3Object.clear()
  echart3Object.setOption({
    grid: {
      left: '2%',
      top: '14%',
      right: '12%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        name: '时',
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: 'rgba(155,208,255,.5)',
          },
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        splitLine: {
          show: false,
        },
        boundaryGap: false,
        data: xdata,
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '降雨量(mm)',
        min: min > 0.2 ? Math.floor((min - 0.2) * 10) / 10 : 0,
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: 'rgba(155,208,255,.5)',
          },
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(255, 255, 255, .5)',
          },
        },
      },
    ],
    series: [
      {
        name: '降雨量',
        type: 'line',
        showAllSymbol: true,
        symbol: 'circle',
        symbolSize: 10,
        itemStyle: {
          color: '#ffe16a',
        },
        lineStyle: {
          width: 2,
          type: 'dotted',
          color: '#ffe16a',
        },
        tooltip: {
          show: false,
        },
        markLine,
        data: ydata,
      },
    ],
  })
}

const select = (val) => {
  selectEchart.value = val
}

const selectChange = (val) => {
  benchmark.value = val
  getData()
}

const getStandardLine = async (factor) => {
  let data = null
  const param = {
    ageLimit: benchmark.value,
    factor,
    indexCode: props.data.id,
  }
  const res = await api.screen.getSwSiteStandardLineUsingPost(param)
  if (res.code === 200) {
    data = res.data
  }
  return data
}

const getData = async () => {
  await api.screen
    .getSwSiteDetailAndGraphUsingPost({ indexCode: props.data.id, time: format(time.value) })
    .then((res) => {
      if (res.code === 200) {
        currentData.value = res.data
        currentFactor.value = currentData.value.datas[0].name
        for (let i = 0; i < currentData.value.datas.length; i++) {
          switch (currentData.value.datas[i].name) {
            case '水位':
              initChart(currentData.value.datas[i].item)
              break
            case '流量':
              initChart2(currentData.value.datas[i].item)
              break
            case '雨量':
              initChart3(currentData.value.datas[i].item)
              break
            default:
          }
        }
      } else {
      }
    })
}

const onTimeChange = async (value) => {
  time.value = value
  getData()
  //   getSwslGraphUsingGET({
  //     factor: this.currentFactor,
  //     tm: this.$moment(this.time).format('yyyy-MM-DD'),
  //     indexCode: this.currentData.stcd,
  //     zl: this.currentData.type,
  //   }).then((data) => {
  //     this.graphData = data;
  //     console.log(this.graphData, 'graphdata');
  //     switch (this.currentFactor) {
  //       case '水位': {
  //         this.initChart();
  //         break;
  //       }
  //       case '流量': {
  //         this.initChart2();
  //         break;
  //       }
  //       case '雨量': {
  //         this.initChart3();
  //         break;
  //       } default: {
  //         console.log('default');
  //       }
  //     }
  //   });
}

function add0(m) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  const time = new Date(shijianchuo)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

onMounted(() => {
  //   currentData.value = props.data
  //   currentFactor.value = currentData.value.factors[0]
  //   // time.value = this.$moment().format('yyyy-MM-DD')
  //   graphData = currentData.value.datas[0].item
  getData()
  echart1Object = proxy.$echarts.init(charts1.value)
  echart2Object = proxy.$echarts.init(charts2.value)
  echart3Object = proxy.$echarts.init(charts3.value)
  // initChart()
  // initChart2()
  // initChart3()
})
</script>

<style lang="scss" scoped>
.title {
  font-size: 2.4rem;
  font-weight: bold;
  height: 6rem;
  line-height: 3.15rem;
  text-align: left;
}
.ylz_container {
  width: 620px;
  .info_content {
    height: 3rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .info_item {
      flex: 1;
      display: flex;

      .item_category {
        margin-right: 2rem;
      }
    }
  }
  .factor_container {
    height: 4rem;
    overflow: hidden;
    align-items: center;
    line-height: 28px;
    .factor {
      display: inline-block;
      min-width: 4rem;
      text-align: center;
      cursor: pointer;
      &.active {
        background-color: #ffffff;
        color: #0088bf;
      }
    }

    .right-box {
      float: right;
      display: flex;
      .condition {
        display: flex;
        .echart-btn {
          padding: 0 0.6rem;
          height: 2.65rem;
          line-height: 2.65rem;
          background-color: transparent;
          border: 0.025rem solid #fff;
          color: #fff;
          cursor: pointer;
          &:last-of-type {
            margin-right: 1rem;
          }
          &.active {
            background-color: #ffffff;
            color: #0088bf;
          }
        }
      }
      .font {
        margin: 0 5px;
      }
    }
    :deep(.n-date-picker) {
      float: right;
      width: 120px;
    }
  }
  .condition {
    .benchmark {
      display: flex;
      justify-content: flex-end;
      span {
        line-height: 26px;
      }
      ::v-deep .n-select {
        width: 110px;
        height: 26px;
        .n-base-selection-label,
        .n-base-selection__state-border,
        .n-base-selection__border {
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
  .charts_container {
    width: 620px;
    height: 240px;
  }
}
</style>
